// @flow

import React from 'react';

type SvgType = {
  className: string,
  fill: string,
  height: string,
  style: Object,
  viewBox: string,
  width: string,
};

const ChevronIcon = ({ className, fill, height, style, viewBox, width }: SvgType) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round">
      <g transform="translate(-292.000000, -700.000000)" fill={fill} stroke={fill}>
        <g transform="translate(286.000000, 698.000000)">
          <g fill="none" transform="translate(7.000000, 3.000000)">
            <polyline id="Path" strokeWidth="2" points="0 10 5 5 0 0" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

ChevronIcon.defaultProps = {
  className: '',
  fill: 'currentColor',
  height: '12px',
  style: {},
  viewBox: '0 0 7 12',
  width: '7px',
};

export default ChevronIcon;
